import * as actions from "../../utils/Actions";

const initialState = {
    showToast: false,
    error: false,
    message: null,
    pageTitle: null
}

export default function global(state = initialState, action){

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type){
        
        case actions.UPDATE_PAGE_TITLE:
            return {
                ...state,
                pageTitle: action.meta.title
            }
        
        case actions.SHOW_ERROR_TOAST:
            
            return {
                ...state,
                showToast: true,
                error: true,
                message: action.meta.message
            }

        case actions.RESET_TOAST:
            return {
                ...state,
                showToast: false,
                error: false,
                message: null
            }

        case actions.pending(actions.SET_ERROR_LOG):
            return {
                ...state,
                showPageLoader: true
            };
        
        case actions.fulfilled(actions.SET_ERROR_LOG):
            return {
                ...state,
                showPageLoader: false
            };
        
        case actions.rejected(actions.SET_ERROR_LOG):
            return {
                ...state,
                showPageLoader: false
            };
        
        default:
            return {...state}
    }

}